<template>
    <div>
        <el-row>
            <div v-for="(results,x) in bigArr" :key="x" class="examTitle">
                <!-- <div class="tyleTwo" style="background:rgb(84, 92, 100);border-left-color:#343a40;color:#fff">
                    {{x+1|TransformToChinese}}、{{results.msg}}<span style="color:#0beb96">[类型：{{getTypeCodeName(results.typeCode)}}]</span>
                    <p style="clear: both;"></p>
                </div> -->
                <div class="groupClass">
                    <el-col class="groupClassSon" :span="24" v-for="(item,index) in results.objArr" :key="index">

                            <div class="titleLeft" :style="{width:(item.typeCode == 70? '50%':'60%')}">
                                <!-- <div class="tyleTwo">{{item.typeName}}</div> -->
                                <div v-if="item.typeCode == 10||item.typeCode==11||item.typeCode==12">
                                    <el-col :span="24" class="ti" align="left"> <viewer class="disIn hybrid questionClass" v-html="`${item.serialNumber}、${item.question}`">{{item.serialNumber}}、{{item.question}}</viewer></el-col>
                                    <el-col :span="24" class="zhi" align="left" v-if="item.detailInfo.audioUrl"><audio :src="item.detailInfo.audioUrl" controls="true" controlslist="nodownload" id="up-audio"></audio><span v-if="item.detailInfo.playTime != -1"> &nbsp;(播放{{item.detailInfo.playTime}}遍)</span><span v-else> &nbsp;(不限次数)</span></el-col>
                                    <el-col :span="24" class="zhi" align="left" v-if="item.detailInfo.questionImgUrl"><viewer><img :src="item.detailInfo.questionImgUrl" alt="" srcset=""></viewer></el-col>
                                    <div v-for="(egg,n) in item.detailInfo.detailsList" :key="n">
                                        <el-col :span="24" class="zhi" align="left">
                                            <viewer :class="[egg.isAnswer=='1'? 'red':'',(/^(A、|B、|C、|D、)<[^>]+>/g).test(egg.msg)? 'a-single':'','disIn hybrid']" v-html="egg.msg">{{egg.msg}}</viewer> &nbsp;&nbsp;&nbsp;&nbsp;
                                        </el-col>
                                    </div>
                                    <!-- <div class="tyleTwo" style="clear: both;margin:10px 0">答案：{{item.selfIsAnswer.join()}}</div> -->
                                </div>
                                <div v-if="item.typeCode == 60">
                                    <el-col :span="24" class="ti" align="left"> <viewer class="disIn hybrid questionClass" v-html="`${item.serialNumber}、${item.question}`">{{item.serialNumber}}、{{item.question}}</viewer></el-col>
                                    <el-col :span="24" class="zhi" align="left" v-if="item.detailInfo.audioUrl"><audio :src="item.detailInfo.audioUrl" @pause="onpause(x,index)" @play="onplay(x,index)" :ref="'tagItem'+(x+index)" controls="true" controlslist="nodownload" id="up-audio"></audio><span v-if="item.detailInfo.playTime != -1"> &nbsp;(播放{{item.detailInfo.playTime}}遍)</span><span v-else> &nbsp;(不限次数)</span></el-col>
                                    <el-col :span="24" class="zhi imgStyle" align="left" v-for="son in item.detailInfo.questionImgUrl.split(',')" :key="son"><viewer><img :src="son" alt="" srcset=""></viewer></el-col>
                                    <div class="blankClass" v-if="item.typeCode == 60">
                                        <div class="daancass">答案</div>
                                        <audio :src="item.detailInfo.rhythmBeatAudioUrl" id="up-audio" controls="true" controlslist="nodownload" style="width: 300px;margin: 2px;height: 40px;"></audio>
                                    </div>
                                </div>
                                <div v-if="item.typeCode == 61">
                                    <el-col :span="24" class="ti" align="left"> <viewer class="disIn hybrid questionClass" v-html="`${item.serialNumber}、${item.question}`">{{item.serialNumber}}、{{item.question}}</viewer></el-col>
                                    <el-col :span="24" class="zhi" align="left" v-if="item.detailInfo.audioUrl"><audio :src="item.detailInfo.audioUrl" @pause="onpause(x,index)" @play="onplay(x,index)" :ref="'tagItem'+(x+index)" controls="true" controlslist="nodownload" id="up-audio"></audio><span v-if="item.detailInfo.playTime != -1"> &nbsp;(播放{{item.detailInfo.playTime}}遍)</span><span v-else> &nbsp;(不限次数)</span></el-col>
                                    <el-col :span="24" class="zhi imgStyle" align="left" v-for="son in item.detailInfo.questionImgUrl.split(',')" :key="son"><viewer><img :src="son" alt="" srcset=""></viewer></el-col>
                                </div>
                                <div v-if="item.typeCode == 70">
                                    <el-col :span="24" class="ti" align="left" style="height: 50px;font-size: 18px;line-height: 50px;color: #000;"> 考试图片</el-col>
                                    <el-col :span="24" class="zhi imgStyle huiTu" align="left"><viewer style="text-align: center;"><img :src="item.detailInfo.imgUrl" alt="" srcset=""></viewer></el-col>
                                    <p style="clear: both;"></p>
                                    <div class="huituBackTm">
                                        <span>{{item.serialNumber}}、{{item.question}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="titleRight" :style="{width:(item.typeCode == 70? '50%':'40%')}">
                                <div v-if="item.typeCode == 10||item.typeCode == 11||item.typeCode == 12" class="titleRightSon">
                                    <div class="huangTop">
                                        <div>考生答案</div>
                                        <span class="dfs">得分：{{item.userScore}}</span>
                                        <span>满分：{{item.score}}</span>
                                    </div>
                                    <div class="huangCenter">
                                        <div class="daAn" :style="{width:(item.userIsAnswer.length>0? '50%':'100%')}">
                                            <strong v-if="item.userIsAnswer.length>0">{{item.userIsAnswer.join()||'未答题'}}</strong>
                                            <div v-else class="noDatas"><span>考生未答题</span></div>
                                        </div> 
                                        <div class="daAnStatus" v-if="item.userIsAnswer.length>0">
                                            <img v-if="item.userScore==item.score" src="../../../static/images/dpDui.png" alt="" srcset="">
                                            <img v-else src="../../../static/images/cuo.png" alt="" srcset="">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.typeCode == 60" class="titleRightSon">
                                    <div class="huangTop">
                                        <div>考生答案</div>
                                        <span class="dfs">得分：{{item.userScore}}</span>
                                        <span>满分：{{item.score}}</span>
                                    </div>
                                    <div class="audioRecognition">
                                        <audio v-if="item.rhythmBeatAudioUrl != '1'" :src="item.rhythmBeatAudioUrl" controls="true" controlslist="nodownload" id="up-audio" style="width:98%;height:40px;margin-top:5px"></audio>
                                        <div v-else class="no60AudioUrl"><span>考生未答题</span></div>
                                        <div class="newAi">
                                            <div class="bgHeard"></div>
                                            <div class="optionsName">
                                                <div>类型</div>
                                                <div style="margin-top: 21.5px;"><p :style="{background:(((item.userScore/item.score)*100)<=20? '#FF0100':'#62F95E')}"></p>节奏</div>
                                            </div>
                                            <div class="optionsOn">
                                                <div></div>
                                                <ul style="margin-top: 21.5px;"><li v-for="xz in theFlash" :class="((item.userScore/item.score)*100)>=xz? ((item.userScore/item.score)*100)<=20? 'liColorR':'liColorG':''"></li></ul>
                                            </div>
                                            <div class="optionsValue">
                                                <div>相似度</div>
                                                <div style="margin-top: 21.5px;">{{Math.floor(((item.userScore/item.score)*100 )* 100) / 100}}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.typeCode == 61" class="titleRightSon">
                                    <div class="huangTop">
                                        <div>考生答案</div>
                                        <span class="dfs">得分：{{item.userScore}}</span>
                                        <span>满分：{{item.score}}</span>
                                    </div>
                                    <div class="audioRecognition">
                                        <audio v-if="item.rhythmSingAudioUrl != '1'" :src="item.rhythmSingAudioUrl" controls="true" controlslist="nodownload" id="up-audio" style="width:98%;height:40px;margin-top:5px"></audio>
                                        <div v-else class="no60AudioUrl"><span>考生未答题</span></div>
                                        <div class="newAi">
                                            <div class="bgHeard"></div>
                                            <div class="optionsName">
                                                <div>类型</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.pitch<=20? '#FF0100':'#62F95E')}"></p>音标</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.rhythm<=20? '#FF0100':'#62F95E')}"></p>节奏</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.speed<=20? '#FF0100':'#62F95E')}"></p>速度</div>
                                            </div>
                                            <div class="optionsOn">
                                                <div></div>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.pitch>=xz? item.detailJsonVal.detail.pitch<=20? 'liColorR':'liColorG':''"></li></ul>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.rhythm>=xz? item.detailJsonVal.detail.rhythm<=20? 'liColorR':'liColorG':''"></li></ul>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.speed>=xz? item.detailJsonVal.detail.speed<=20? 'liColorR':'liColorG':''"></li></ul>
                                            </div>
                                            <div class="optionsValue">
                                                <div>相似度</div>
                                                <div>{{item.detailJsonVal.detail.pitch}}%</div>
                                                <div>{{item.detailJsonVal.detail.rhythm}}%</div>
                                                <div>{{item.detailJsonVal.detail.speed}}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.typeCode == 70" class="titleRightSon">
                                    <div class="huangTop">
                                        <div>考生答案</div>
                                        <span class="dfs">得分：{{item.userScore}}</span>
                                        <span>满分：{{item.score}}</span>
                                    </div>
                                    <div class="audioRecognitionHuiTu" style="margin-top:15px">
                                        <viewer style="width:100%;height:300px;display: flex;vertical-align: middle;align-items: center;">
                                            <img :src="item.drawImgUrl" v-if="item.drawImgUrl" alt="" srcset="" style="max-height: 300px;max-width: 100%;margin:auto;">
                                            <div v-else class="n070DrawImgUrl"><span>考生未答题</span></div>
                                        </viewer>
                                        <div class="newAi">
                                            <div class="bgHeard"></div>
                                            <div class="optionsName">
                                                <div>类型</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.edge<=20? '#FF0100':'#62F95E')}"></p>轮廓</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.color<=20? '#FF0100':'#62F95E')}"></p>色彩</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.structure<=20? '#FF0100':'#62F95E')}"></p>构图</div>
                                                <div><p :style="{background:(item.detailJsonVal.detail.contour<=20? '#FF0100':'#62F95E')}"></p>线条</div>
                                            </div>
                                            <div class="optionsOn">
                                                <div></div>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.edge>=xz? item.detailJsonVal.detail.edge<=20? 'liColorR':'liColorG':''"></li></ul>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.color>=xz? item.detailJsonVal.detail.color<=20? 'liColorR':'liColorG':''"></li></ul>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.structure>=xz? item.detailJsonVal.detail.structure<=20? 'liColorR':'liColorG':''"></li></ul>
                                                <ul><li v-for="xz in theFlash" :class="item.detailJsonVal.detail.contour>=xz? item.detailJsonVal.detail.contour<=20? 'liColorR':'liColorG':''"></li></ul>
                                            </div>
                                            <div class="optionsValue">
                                                <div>相似度</div>
                                                <div>{{item.detailJsonVal.detail.edge}}%</div>
                                                <div>{{item.detailJsonVal.detail.color}}%</div>
                                                <div>{{item.detailJsonVal.detail.structure}}%</div>
                                                <div>{{item.detailJsonVal.detail.contour}}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </el-col>

                    <p style="clear: both;"></p>
                </div>
            </div>
        </el-row>
        <audio ref="tock" :src="tockUrl" v-show="false"></audio>
    </div>
</template>
<script>
import { json_P } from '../../../../../acg-web/src/lib/util'
import utils from '../../lib/util'
    export default {
        data() {
            return {
                newObj:{
                    objArr:[],
                    msg:'',
                    bId:'',
                    typeCode:'',
                },
                rules:{},
                bigArr:[],
                visible: false,
                textData:{},
                bigQuestion:{},
                titleNum:null,
                addTypeCode:null,
                tockUrl:require('../../../static/music/tock.wav'),
                fleg:false,
                leftPlay:false,
                setTime:'',
                playArr:[],
                theirPapers:10,
                theFlash:[1,20,30,40,50,60,70,80,90,100],
                moRen_61:{code:0,detail: {pitch: 0,rhythm: 0,speed: 0},score: 0},
                moRen_70:{code: 0,detail: {color: 0,contour: 0,edge: 0,structure: 0},score: 0},
                moArr:['61','70']
            }
        },
        components:{
        },
        watch: {
        },
        computed: {
            defaultImg(){
                return 'this.src="https://aitestgo-bj.oss-cn-beijing.aliyuncs.com/acg/examresource/16056941200001605694082545.png?x-oss-process=image/resize,m_lfit,h_100,w_100"'
            },
        },
        created(){
        },
        mounted(){
            this.$nextTick(()=>{

            })
        },
        methods: {
            editData(v){
                let val = utils.deepClone2(v)
                let that = this
                let serialNumber = 0
                for (let i = 0; i < val.length; i++) {
                    that.newObj = {
                        objArr:[],
                        msg:val[i].msg,
                        bId:val[i].bId,
                        typeCode:val[i].typeCode,
                    }
                    that.bigArr.push(that.newObj)
                    for (let k = 0; k < val[i].questionList.length; k++) {
                        that.bigArr[i].objArr.push(
                            val[i].questionList[k].questionDto
                        )
                        let ele = that.bigArr[i].objArr[k];
                        if(that.bigArr[i].objArr[k].detailJsonVal){
                           that.bigArr[i].objArr[k].detailJsonVal = JSON.parse(that.bigArr[i].objArr[k].detailJsonVal)
                        }else{if(that.moArr.indexOf(that.bigArr[i].objArr[k].typeCode)!=-1)
                            that.workingMoRen(that.bigArr[i].objArr[k].typeCode,(obj)=>{console.log(obj),that.bigArr[i].objArr[k].detailJsonVal = obj})
                            else that.bigArr[i].objArr[k].detailJsonVal = ''
                        }
                        serialNumber++;
                        that.bigArr[i].objArr[k]['serialNumber'] = serialNumber
                        ele['score'] = val[i].questionList[k].score
                        ele.fillBlankVal = ele.fillBlankVal? ele.fillBlankVal:''
                        
                        ele.question = utils.dealText(ele.question);
                        if(ele.typeCode==10||ele.typeCode==11||ele.typeCode==12){
                            ele['selfIsAnswer'] = []
                            ele['userIsAnswer'] = []
                            ele.detailInfo.detailsList = ele.detailInfo.detailsList.map(function(item,index){
                                item.msg = (index==0? 'A、':index==1? 'B、':index==2? 'C、':index==3? 'D、':'') +utils.dealText(item.msg)
                                if(item.isAnswer == 1) ele.selfIsAnswer.push(index==0? 'A':index==1? 'B':index==2? 'C':index==3? 'D':'')
                                if(ele.selectIds){
                                    if(ele.typeCode==10){
                                        if(ele.selectIds == item.bId){
                                            ele['userIsAnswer'].push(index==0? 'A':index==1? 'B':index==2? 'C':index==3? 'D':'')
                                        }
                                    }else{
                                        if(ele.selectIds.indexOf(item.bId)!=-1){
                                            ele['userIsAnswer'].push(index==0? 'A':index==1? 'B':index==2? 'C':index==3? 'D':'')
                                        }
                                    }
                                }
                                return item
                            })
                        }
                        if(ele.typeCode==60||ele.typeCode==61){
                            that.$set(ele, 'loadings', false)
                        }
                    }
                }
            },
            getTypeCodeName(code){
                for (let i = 0; i < this.bigQuestion.length; i++) {
                    if(this.bigQuestion[i].typeCode == code){
                        return this.bigQuestion[i].typeName
                    }
                }
            },
            onplay(x,index){
                let that = this
                that.$store.commit('get_indexString',x+','+index)
            },
            onpause(x,index){
                let that = this
                if(that.fleg&&JSON.stringify([index,x]) == JSON.stringify(that.playArr)){
                    let audioX = eval("this.$refs.tagItem" + (index + x))[0]
                    if(!audioX.ended){
                        audioX.paused&&audioX.currentTime>0? audioX.play():audioX.pause()
                    }else{
                        that.fleg = false
                        that.playArr = []
                        that.$set(that.bigArr[x].objArr[index], 'loadings', false)
                    }
                }
            },
            workingMoRen(typecode,callBack){
                let obj = '';
                switch(typecode){
                    case '61':
                        obj = this.moRen_61;
                        break;
                    case '70':
                        obj = this.moRen_70;
                        break;
                    default:
                        obj = ''
                        break;
                }
                return callBack(obj)
            },
        }
    }
</script>
<style scoped lang="less">
    .tyleTwo{
        border-left: 5px solid #CCC;
        padding:5px;
        background: #EEE;
        box-sizing: border-box;
        text-align: left;
    }
    .groupClass{
        padding: 0px 10px;
    }
    .groupClassSon{
        border-top: 1px solid #EDEEED;
        display: flex;
        align-items:stretch;
    }
    .titleLeft{
        float:left;
        width:60%;
        /* border: 1px solid #ccc; */
        box-sizing: border-box;
        padding: 10px;
    }
    .titleRight{
        float: right;
        width: 40%;
        height: inherit;
        margin-right: -5px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 5px;
        .titleRightSon{
            width: 100%;
            height: 100%;
            .huangTop{
                display: inline-block;
                font-weight: bold;
                width: 94%;
                padding-top: 24px;
                box-sizing: border-box;
                div{
                    font-size: 18px;
                    color: #000;
                    font-weight: normal;
                    float: left;
                }
                span{
                    color: #000;
                    font-size: 15px;
                    margin-left: 15px;
                    float: right;
                }
                .dfs{color: #0045B2;}
            }
            .huangCenter{
                height: 55%;
                width: 94%;
                margin: 0 3%;
                background: #F5F9FE;
                border-radius: 4px;
                .daAn{
                    float: left;
                    width: 50%;
                    height: 100%;
                    display: table;
                    strong{
                        font-size: 30px;
                        display: table-cell;
                        vertical-align: middle;
                    }
                }
                .daAnStatus{
                    float: right;
                    width: 50%;
                    height: 100%;
                    position: relative;
                    img{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        left: 0;
                        margin: auto;
                        width: 27px;
                    }
                }
            }
            .audioRecognition{
                height: 100%;
                width: 94%;
                margin: 0 3%;
                margin-top: -50px;
                box-sizing: border-box;
                padding-top: 50px;
                .no60AudioUrl{
                    height: 45%;
                    height: -moz-calc(100% - 164px);
                    height: -webkit-calc(100% - 164px);
                    height: calc(100% - 164px);
                    width: 100%;
                    border-radius: 4px;
                    box-sizing: border-box;
                    background-color: #F5F9FE;
                    background-image: url('../../../static/images/no70img.png');
                    background-repeat: no-repeat;
                    background-size:auto 60%;
                    background-position: 50% 45%;
                    position: relative;
                    span{
                        position: absolute;
                        bottom: 7%;
                        left: 0;
                        right: 0;
                        margin: 0 auto;
                        font-weight: bold;
                    }
                }
                .newAi{
                    height: 134px;
                    max-height: 134px;
                    margin-top: 10px;
                    border-radius: 4px;
                    // background-image: url('../../../static/images/aiRoutionPageBG.png');
                    // background-repeat: no-repeat;
                    // background-size: 100% 100%;
                    background: #F5F9FE;
                    box-sizing: border-box;
                    padding: 10px;
                    .bgHeard{
                        width: 25%;
                        height: 100%;
                        float: left;
                        background-image: url('../../../static/images/aiRutionPage.png');
                        background-repeat: no-repeat;
                        background-size: 86% auto;
                        background-position: 50%;
                    }
                    .optionsName{
                        width: 17%;
                        height: 100%;
                        float: left;
                        box-sizing: border-box;
                        padding: 0 4px;
                        div{
                            height: 19%;
                            margin: 5px 0;
                            font-size: 12.6px;
                            line-height: 21.5px;
                            box-sizing: border-box;
                            padding-right: 4px;
                            p{
                                display: inline-block;
                                width:4px;
                                height:4px;
                                background: #62F95E;
                                border-radius: 50%;
                                margin: 3px 5px;
                            }
                        }
                        div:nth-child(1){
                            color: #9094A7;
                            margin: 0;
                            text-align: center;
                            padding-right: 0px;
                        }
                        div:nth-child(2),
                        div:nth-child(3),
                        div:nth-child(4){
                            border: 1px solid #D4D5D4;
                            text-align: right;
                            color: #000;
                        }
                    }
                    .optionsOn{
                        width: 46%;
                        height: 100%;
                        float: left;
                        box-sizing: border-box;
                        padding: 0px 6px;
                        div{
                            margin: 0;
                            height: 19%;
                            width: 100%;
                        }
                        ul{
                            height: 19%;
                            width: 100%;
                            margin: 5px 0;
                        }
                        ul li{
                            float: left;
                            width: 8%;
                            margin-right: 2%;
                            height: 100%;
                            background-image: linear-gradient(to right, #4A4B4A 0%, #4A4B4A 65%, transparent 50%);
                            background-size: 44px 4px;
                            background-repeat: no-repeat;
                            background-position: 0;
                        }
                        .liColorR{background-image: linear-gradient(to right, #FF0100 0%, #FF0100 65%, transparent 50%);}
                        .liColorG{background-image: linear-gradient(to right, #62F95E 0%, #62F95E 65%, transparent 50%);}
                    }
                    .optionsValue{
                        width: 12%;
                        height: 100%;
                        float: left;
                        div{
                            height: 19%;
                            margin: 5px 0;
                            font-size: 14px;
                            box-sizing: border-box;
                            padding-right: 4px;
                        }
                        div:nth-child(1){
                            color: #9094A7;
                            margin: 0;
                            font-size: 12px;
                            text-align: center;
                        }
                        div:nth-child(2),
                        div:nth-child(3),
                        div:nth-child(4){
                            line-height: 21.5px;
                            color: #000;
                        }
                    }
                }
            }
            .noDatas{
                height: 100%;
                width: 100%;
                margin: auto;
                background-image: url('../../../static/images/no70img.png');
                background-repeat: no-repeat;
                background-size:auto 60%;
                background-position: 50% 20%;
                position: relative;
                span{
                    position: absolute;
                    bottom: 7%;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    font-size: 15px;
                    font-weight: bold;
                }
            }
            .audioRecognitionHuiTu{
                height: 55%;
                width: 100%;
                box-sizing: border-box;
                padding: 0 12px;
                .n070DrawImgUrl{
                    height: 100%;
                    width: 100%;
                    margin: auto;
                    border-radius: 4px;
                    background-color: #F5F9FE;
                    background-image: url('../../../static/images/no70img.png');
                    background-repeat: no-repeat;
                    background-size:60%;
                    background-position: 50% 45%;
                    position: relative;
                    span{
                        position: absolute;
                        bottom: 10%;
                        left: 0;
                        right: 0;
                        margin: 0 auto;
                        font-weight: bold;
                    }
                }
                .newAi{
                    height: 60%;
                    max-height: 134px;
                    margin-top: 16px;
                    border-radius: 4px;
                    // background-image: url('../../../static/images/aiRoutionPageBG.png');
                    // background-repeat: no-repeat;
                    // background-size: 100% 100%;
                    background: #F5F9FE;
                    box-sizing: border-box;
                    padding: 10px;
                    .bgHeard{
                        width: 25%;
                        height: 100%;
                        float: left;
                        background-image: url('../../../static/images/aiRutionPage.png');
                        background-repeat: no-repeat;
                        background-size: 84% auto;
                        background-position: 50%;
                    }
                    .optionsName{
                        width: 17%;
                        height: 100%;
                        float: left;
                        box-sizing: border-box;
                        padding: 0 9px;
                        div{
                            height: 16%;
                            margin: 4px 0;
                            font-size: 12.5px;
                            -webkit-box-sizing: border-box;
                            box-sizing: border-box;
                            padding-right: 9px;
                            p{
                                display: inline-block;
                                width:4px;
                                height:4px;
                                background: #62F95E;
                                border-radius: 50%;
                                margin: 2px 6px;
                            }
                        }
                        div:nth-child(1){
                            color: #9094A7;
                            margin: 0;
                            text-align: center;
                            padding-right: 0px;
                        }
                        div:nth-child(2),
                        div:nth-child(3),
                        div:nth-child(4),
                        div:nth-child(5){
                            border: 1px solid #D4D5D4;
                            text-align: right;
                            color: #000;
                        }
                    }
                    .optionsOn{
                        width: 46%;
                        height: 100%;
                        float: left;
                        box-sizing: border-box;
                        padding: 0px 6px;
                        div{
                            margin: 0;
                            height: 16%;
                            width: 100%;
                        }
                        ul{
                            height: 16%;
                            width: 100%;
                            margin: 4px 0;
                        }
                        ul li{
                            float: left;
                            width: 8%;
                            margin-right: 2%;
                            height: 100%;
                            background-image: linear-gradient(to right, #4A4B4A 0%, #4A4B4A 65%, transparent 50%);
                            background-size: 44px 4px;
                            background-repeat: no-repeat;
                            background-position: 0;
                        }
                        .liColorR{background-image: linear-gradient(to right, #FF0100 0%, #FF0100 65%, transparent 50%);}
                        .liColorG{background-image: linear-gradient(to right, #62F95E 0%, #62F95E 65%, transparent 50%);}
                    }
                    .optionsValue{
                        width: 12%;
                        height: 100%;
                        float: left;
                        div{
                            height: 16%;
                            margin: 4px 0;
                            font-size: 13px;
                            box-sizing: border-box;
                            padding-right: 4px;
                        }
                        div:nth-child(1){
                            color: #9094A7;
                            margin: 0;
                            font-size: 12px;
                            text-align: center;
                        }
                        div:nth-child(2),
                        div:nth-child(3),
                        div:nth-child(4),
                        div:nth-child(5){
                            line-height: 21.5px;
                            color: #000;
                        }
                    }
                }
            }
        }
    }
    .questionClass{
        margin: 10px 0;
        font-size: 16px;
    }
    .ti{
        margin: 5px 0;
    }
    .zhi{
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 15px;
        margin: 1px 0;
    }
    .zhi img{
        max-width: 70%;
        max-height: 240px;
    }
    .red{
        color: red;
    }
    .disIn{display: inline-block;}
    .blankClass{
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding-left: 10px;
        .daancass{
            margin: 2px 0px 0px -8px;
            width: 60px;
            float: left;
            height: 40px;
            line-height: 40px;
            border-left: 5px solid #004BB4;
            background: #EEF6FE;
            color: #000;
            box-sizing: border-box;
            padding-left: 8px;
            margin-right: 10px;
        }
    }
    .huiTu{
        img{
            max-height: 300px;
            max-width: 100%;
        }
    }
    .huituBackTm{
        background: #F5F9FE;
        border-radius: 4px;
        height: 134px;
        max-height: 134px;
        margin-top: 10px;
        width: 100%;
        display: table;
        span{
            display: table-cell;
            vertical-align: middle;
            color: #000;
            font-size: 16px;
            text-align: center;
        }
    }
</style>
<style>
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .hybrid .tableimg{
        height: 50px;
        width: 90px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .hybrid .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        /* right: 0; */
        bottom: 0;
        left: 0;
        display: block;
        /* margin: auto; */
    }
    .hybrid video{
        width: 130px;
        height: 100px;
        outline: none;
    }   
    .hybrid audio{
        width: 250px;
        height: 35px;
        outline: none;
        display: block;
    }
    #up-audio{
        outline:none;
        height: 40px;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/pages/cpResults/groupTitle.vue